/**
 * This factory is a singleton, so we can use it to track the user's communication preferences between the
 * EDeliveryInlineDirective and the parent view.
 */
var EDeliveryFactory = function ($resource, $window) {
    // API endpoints
    var retrieveParticipantConsentApi =
        "/participant-web-services/rest/partialauth/ecommService/participantConsent/:gaId";
    var updateParticipantConsentApi =
        "/participant-web-services/rest/partialauth/ecommService/updateParticipantConsent";

    // Private variables
    var _allowedToOverwrite = false, // True if the participant is allowed to change their e-delivery preference
        _gaId = null, // The group id
        _planName = null, // The plan name
        _pptConsent = false, // True if the participant has consented for e-delivery
        _eDeliveryOption = null, // The current communication preference
        _docTypes = null, // The types of documents the participant will receive
        _econsentEmail = null, // The primary email address for the participant
        _secondaryEmail = null, // The secondary email address for the participant
        _selectedEmail = null, // The email address the participant has selected to receive communications
        _selectedEDeliveryOption = null, // The e-delivery communication preference selected by the participant
        _form = null; // The e-delivery form

    // All possible communication preference values
    var CommunicationPreferences = {
        EDELIVERY_ONLY: "YES_CONSENT_ANY_ELECTRONIC", // The participant has chosen "e-delivery"
        EDELIVERY_AND_MAIL: "YES_CONSENT_ALL_MAIL", // The participant has chosen "e-delivery and by mail"
        ALLOW_DEFAULT_EDELIVERY: "NO_CONSENT_ANY_ELECTRONIC", // The participant has not chosen a preference, but the plan defaults to "e-delivery"
        NO_CONSENT_ALL_MAIL: "NO_CONSENT_ALL_MAIL" // The participant has not chosen a preference, but the plan defaults to "e-delivery and by mail"
    };

    return {
        retrieveParticipantConsent: $resource(
            __baseApiUrl__ + retrieveParticipantConsentApi,
            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        ),

        updateParticipantConsent: $resource(
            __baseApiUrl__ + updateParticipantConsentApi,
            {},
            {
                query: {
                    method: "POST",
                    isArray: false,
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            }
        ),

        getAllowedToOverwrite: function () {
            return _allowedToOverwrite;
        },
        setAllowedToOverwrite: function (allowedToOverwrite) {
            _allowedToOverwrite = allowedToOverwrite === true || allowedToOverwrite === "true";
        },

        getGaId: function () {
            return _gaId;
        },
        setGaId: function (gaId) {
            _gaId = gaId;
        },

        getPlanName: function () {
            return _planName;
        },
        setPlanName: function (planName) {
            _planName = planName;
        },

        getPptConsent: function () {
            return _pptConsent;
        },
        setPptConsent: function (pptConsent) {
            _pptConsent = pptConsent === true || pptConsent === "true";
        },

        getEDeliveryOption: function () {
            return _eDeliveryOption;
        },
        setEDeliveryOption: function (eDeliveryOption) {
            _eDeliveryOption = eDeliveryOption;
        },

        getDocTypes: function () {
            return _docTypes;
        },
        setDocTypes: function (docTypes) {
            _docTypes = docTypes;
        },

        // The primary email address
        getEConsentemailAddress: function () {
            return _econsentEmail;
        },
        setEConsentemailAddress: function (econsentEmail) {
            _econsentEmail = econsentEmail;
        },

        // The secondary email address
        getSecondaryEmail: function () {
            return _secondaryEmail;
        },
        setSecondaryEmail: function (secondaryEmail) {
            _secondaryEmail = secondaryEmail;
        },

        getEmailChoices: function () {
            var choices = [];

            if (_econsentEmail !== null) {
                choices.push(_econsentEmail);
            }

            if (_secondaryEmail !== null) {
                choices.push(_secondaryEmail);
            }

            return choices;
        },

        /**
         * Get the selected email address. If no email address has been selected, default to the
         * primary email address. If the primary is not available, default to the secondary email.
         
         * @return {Mixed} The selected email address or null if no email address is on file
         */
        getSelectedEmail: function () {
            if (_selectedEmail !== null) {
                return _selectedEmail;
            }

            return _econsentEmail !== null ? _econsentEmail : _secondaryEmail;
        },
        setSelectedEmail: function (selectedEmail) {
            _selectedEmail = selectedEmail;
        },

        // The chosen e-delivery value
        getSelectedEDeliveryOption: function () {
            return _selectedEDeliveryOption;
        },
        setSelectedEDeliveryOption: function (selectedEDeliveryOption) {
            _selectedEDeliveryOption = selectedEDeliveryOption;
        },

        getSelectedConsentInd: function () {
            return _selectedEDeliveryOption === CommunicationPreferences.EDELIVERY_ONLY;
        },

        getForm: function () {
            return _form;
        },
        setForm: function (form) {
            console.log("EDeliveryFactory::setForm called with ", form);
            _form = form;
        },

        CommunicationPreferences: CommunicationPreferences
    };
};

EDeliveryFactory.$inject = ["$resource", "$window"];
export default EDeliveryFactory;
